<dhp-article-purchase-account-shell
  [eyebrowKey]="'pages.articlePurchase.accountRegister.eyebrow'"
  [titleKey]="'pages.articlePurchase.accountRegister.title'"
  [descriptionKey]="'pages.articlePurchase.accountRegister.subtitle'"
  [noticeKey]="'pages.articlePurchase.accountRegister.notice'"
>
  <dhp-auth-base-form
    [formGroup]="form"
    [layoutMode]="'fullWidth'"
    [showHeader]="false"
    [submitText]="'pages.articlePurchase.accountRegister.submit' | translate"
    [submitAction]="createAccount()"
    [title]="''"
  >
    <ng-container ngProjectAs="form">
      <dhp-create-account-fields
        [creationFailed]="creationFailed()"
        [formGroup]="form"
        [requirements]="requirements"
      ></dhp-create-account-fields>
    </ng-container>

    <ng-container ngProjectAs="links">
      <div class="flex flex-wrap items-center gap-2">
        <span class="text-base text-primary-text">
          {{
            'pages.articlePurchase.accountRegister.alreadyHaveAccount'
              | translate
          }}
        </span>
        <button
          class="text-link-color-primary text-base underline"
          (click)="navigateToLogin()"
          type="button"
        >
          {{ 'pages.articlePurchase.accountRegister.loginLink' | translate }}
        </button>
      </div>
    </ng-container>
  </dhp-auth-base-form>
</dhp-article-purchase-account-shell>
